import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AgeGate from "@/components/AgeGate";
import BarkBark from "@/components/BarkBark";
import PromoBanner from "@/components/PromoBanner";

export default function PublicLayout() {
  return (
    <div className="ha-storefront min-h-screen flex flex-col bg-black text-sand">
      <AgeGate />
      <PromoBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BarkBark />
    </div>
  );
}
